// 加盟亚朵
export default [
    {
        path: '/joinAtour',
        component: () => import(/* webpackChunkName:"joinAtour"*/'@/pages/join/index.vue'),
        name: 'JoinAtour',
        // 设置默认指向的路径
        redirect: '/joinAtour/jituan',
        meta: {
            title: '加盟亚朵',
        },
        children: [
            {
                path: '/joinAtour/:type',
                component: () => import(/* webpackChunkName:"joinAtour"*/'@/pages/join/brands/brand.vue'),
                name: 'JoinAtourBrand',
                meta: {
                    title: '加盟亚朵',
                },
            },
        ],
    },
];
